/**
 * До cutoffHour:00 по Europe/Moscow (не включая этот час) — «сегодня» по часам разрешён.
 * Например 18 → с 18:00:00 МСК и позже возвращает false.
 */
export function isMskTodayDeliveryByClock(cutoffHour = 18, now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Moscow',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).formatToParts(now);
  const hour = parseInt(parts.find((p) => p.type === 'hour').value, 10);
  const minute = parseInt(parts.find((p) => p.type === 'minute').value, 10);
  return hour * 60 + minute < cutoffHour * 60;
}

export function isTodayDeliveryChoosable(todayDeliveryEnabled, cutoffHour = 18, now = new Date()) {
  return !!todayDeliveryEnabled && isMskTodayDeliveryByClock(cutoffHour, now);
}
